var map = {
	"./de/btn-detail.png": "8Pw5",
	"./en/btn-detail.png": "NdBr",
	"./es/btn-detail.png": "0aEs",
	"./fr/btn-detail.png": "Y3I6",
	"./ja/btn-detail.png": "2PEJ",
	"./ko/btn-detail.png": "+MUn",
	"./pt/btn-detail.png": "lHqp",
	"./ru/btn-detail.png": "9keJ",
	"./th/btn-detail.png": "5hi1",
	"./zh-Hant/btn-detail.png": "UZ3K"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+nG/";